var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.1/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cp class=\"u-p2x\"\u003ENotifications are temporarily unavailable while we do some maintenance.\u003C\u002Fp\u003E";;return pug_html;};
module.exports = template;